import React from 'react';
import { IProductModalProps } from './AddProductModal';
import { sortBy } from 'lodash';
import { WidthAndHeightSubProps } from '../../puck/reusable-props/widthAndHeight';
import { Cart, ShippingMethod } from '../../interface/checkoutInterface';
import { Shop } from '../../interface/storeInterface';
import './../text-editor/style.scss';
import checkoutService from '../../api/checkoutService';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { StoreProps } from '../../services/constants';
import { setCartData } from '../../redux/slices/cartSlice';
import { setAvailableShippingMethods } from '../../redux/slices/checkoutSlice';
import { CustomizeProps } from '../../interface/commonInterface';
import './index.scss';
import { PaddingType } from '../../puck/reusable-props/padding';
import { getBorderProps, getPaddingStyles } from '../../utils/helper';
import { IBorderValueProps } from '../../puck/reusable-props/Border';

type tagstyle = {
  isBlink: string;
  borderTopLeft: string;
  borderTopRight: string;
  borderBottomLeft: string;
  borderBottomRight: string;
  padding: PaddingType;
  backgroundColor: string;
};
export interface PreviewProductProps {
  pageId: string | null;
  data: IProductModalProps[];
  selectedProduct: number;
  setSelectedProduct: (_value: number) => void;
  currentDeviceType: 'desktop' | 'mobile' | 'tablet';
  image: WidthAndHeightSubProps;
  cartData?: Cart | null;
  dispatch?: ThunkDispatch<StoreProps, unknown, AnyAction>;
  storeData?: Shop;
  productTitle: CustomizeProps;
  maxContainerWidth: string;
  borderForProducts: IBorderValueProps;
  radioColor: string;
  radioSize: string;
  tagPosition: string;
  tagStyles: tagstyle;
  leftTagStyles: tagstyle;
  selectionStyle: {
    isToggle: boolean;
    bannerStyle: {
      backgroundColor: string;
      titleColor: string;
      border: IBorderValueProps;
      shadow: string;
    };
  };
  editMode?: boolean;
}

export const PreviewProduct: React.FC<PreviewProductProps> = ({
  pageId,
  data,
  selectedProduct,
  currentDeviceType,
  image,
  setSelectedProduct,
  cartData,
  storeData,
  dispatch,
  productTitle,
  tagStyles,
  leftTagStyles,
  maxContainerWidth,
  borderForProducts,
  radioColor,
  radioSize,
  tagPosition,
  selectionStyle,
  editMode,
}) => {
  const sortedData = sortBy(data || [], 'order');
  const [loading, setLoading] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const hasAnyLeftTag = sortedData?.some(
    item => item?.isLeftTag && item?.leftTagText,
  );
  function removeBackgroundColor(htmlString: string) {
    return htmlString.replace(/background-color\s*:\s*[^;"]+;?/gi, '');
  }

  const getProductStyles = (isSelected: boolean): React.CSSProperties => {
    if (!selectionStyle?.isToggle && isSelected) {
      const borderProps = getBorderProps(
        selectionStyle?.bannerStyle?.border,
        currentDeviceType,
      );
      return {
        backgroundColor: selectionStyle?.bannerStyle?.backgroundColor,
        ...borderProps,
      };
    } else {
      const borderProps = getBorderProps(borderForProducts, currentDeviceType);
      return {
        ...borderProps,
      };
    }
  };

  const getTitleColor = (isSelected: boolean) => {
    if (!selectionStyle?.isToggle && isSelected) {
      return selectionStyle?.bannerStyle?.titleColor;
    } else {
      return productTitle?.textColor?.[currentDeviceType];
    }
  };

  function calculateMaxLeftTagHeight(
    items: IProductModalProps[],
    leftTagStyles: tagstyle,
    deviceType: 'desktop' | 'mobile' | 'tablet',
  ): number {
    return items?.reduce((max, item) => {
      if (item?.isLeftTag && item?.leftTagText) {
        const html = item?.leftTagText;

        const fontMatch = html?.match(/font-size\s*:\s*(\d+)px/i);
        const fontSize = fontMatch ? parseInt(fontMatch[1], 10) : 14;
        const textHeight = fontSize;

        const paddingTop = parseInt(
          leftTagStyles?.padding?.paddingTop?.[deviceType] || '0',
        );
        const paddingBottom = parseInt(
          leftTagStyles?.padding?.paddingBottom?.[deviceType] || '0',
        );

        const totalHeight = textHeight + paddingTop + paddingBottom;

        return Math.max(max, totalHeight);
      }
      return max;
    }, 0);
  }
  const maxLeftTagHeight = calculateMaxLeftTagHeight(
    sortedData,
    leftTagStyles,
    currentDeviceType,
  );

  const imgWidth = isNaN(+image?.maxWidth?.[currentDeviceType])
    ? image?.maxWidth?.[currentDeviceType]
    : +image?.maxWidth?.[currentDeviceType];

  const imgHeight = isNaN(+image?.height[currentDeviceType])
    ? image?.height[currentDeviceType]
    : +image?.height[currentDeviceType];
  return (
    <>
      {sortedData?.map((item, index) => {
        const inputId = `productSelection-${index}`;
        let isSelected;
        if (selectedProduct) {
          isSelected = item?.productDetails?.id === selectedProduct;
        } else {
          isSelected = index === 0;
        }

        const productStyles = getProductStyles(isSelected);
        const titleColor = getTitleColor(isSelected);
        return (
          <div className="flex p-0 m-0" key={index} style={{ gap: '5px' }}>
            {hasAnyLeftTag && (
              <div style={{ width: maxLeftTagHeight }}>
                {item?.isLeftTag && item?.leftTagText && (
                  <div className="flex-shrink-0 flex items-center justify-center h-full w-full ">
                    {' '}
                    <div
                      className="rounded-t-md p-0 m-0"
                      style={{
                        transform: 'rotate(-90deg)',
                        transformOrigin: 'center center',
                        whiteSpace: 'nowrap',
                        backgroundColor: leftTagStyles?.backgroundColor,
                        borderTopLeftRadius: isNaN(
                          +leftTagStyles?.borderTopLeft,
                        )
                          ? leftTagStyles?.borderTopLeft
                          : leftTagStyles?.borderTopLeft + 'px',
                        borderTopRightRadius: isNaN(
                          +leftTagStyles?.borderTopRight,
                        )
                          ? leftTagStyles?.borderTopRight
                          : leftTagStyles?.borderTopRight + 'px',
                        borderBottomLeftRadius: isNaN(
                          +leftTagStyles?.borderBottomLeft,
                        )
                          ? leftTagStyles?.borderBottomLeft
                          : leftTagStyles?.borderBottomLeft + 'px',
                        borderBottomRightRadius: isNaN(
                          +leftTagStyles?.borderBottomRight,
                        )
                          ? leftTagStyles?.borderBottomRight
                          : leftTagStyles?.borderBottomRight + 'px',
                      }}>
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.leftTagText }}
                        style={{
                          ...getPaddingStyles(
                            leftTagStyles?.padding,
                            currentDeviceType,
                          ),
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="w-full gap-3">
              <label
                key={item.order}
                htmlFor={inputId}
                className={`flex items-center gap-3 ${!(!selectionStyle?.isToggle && isSelected) && item?.isHighlight ? 'elevate-scale' : ''} 
    px-[10px] 
    ${item.isTag && item.tagText && tagPosition === 'top' ? 'pt-[10px] pb-[20px]' : 'pt-[10px] pb-[10px]'} 
    transition-colors duration-200 
    ${isSelected && !selectionStyle?.isToggle ? selectionStyle?.bannerStyle?.border?.borderStyle?.[currentDeviceType] + ' ' + selectionStyle?.bannerStyle?.shadow : borderForProducts?.borderStyle?.[currentDeviceType]} 
    ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} text-editor-content`}
                style={{
                  ...productStyles,
                  backgroundColor:
                    !selectionStyle?.isToggle && isSelected
                      ? selectionStyle?.bannerStyle?.backgroundColor
                      : item?.isHighlight && item?.highlightColor
                        ? item?.highlightColor
                        : 'inherit',
                }}>
                <div className="w-full">
                  {item?.isTag &&
                    item?.tagText &&
                    tagPosition.includes('top') && (
                      <div
                        className="w-full"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems:
                            tagPosition === 'top-center'
                              ? 'center'
                              : tagPosition === 'top-right'
                                ? 'flex-end'
                                : 'flex-start',
                        }}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: removeBackgroundColor(item.tagText),
                          }}
                          className={`${tagStyles?.isBlink === 'yes' ? 'pulsing-button' : ''} overflow-hidden ml-2`}
                          style={{
                            ...getPaddingStyles(
                              tagStyles?.padding,
                              currentDeviceType,
                            ),
                            width: maxContainerWidth,
                            backgroundColor: tagStyles?.backgroundColor,
                            borderTopLeftRadius: isNaN(
                              +tagStyles?.borderTopLeft,
                            )
                              ? tagStyles?.borderTopLeft
                              : tagStyles?.borderTopLeft + 'px',
                            borderTopRightRadius: isNaN(
                              +tagStyles?.borderTopRight,
                            )
                              ? tagStyles?.borderTopRight
                              : tagStyles?.borderTopRight + 'px',
                            borderBottomLeftRadius: isNaN(
                              +tagStyles?.borderBottomLeft,
                            )
                              ? tagStyles?.borderBottomLeft
                              : tagStyles?.borderBottomLeft + 'px',
                            borderBottomRightRadius: isNaN(
                              +tagStyles?.borderBottomRight,
                            )
                              ? tagStyles?.borderBottomRight
                              : tagStyles?.borderBottomRight + 'px',
                          }}
                        />
                      </div>
                    )}
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center gap-4 w-full">
                      <input
                        type="radio"
                        style={{
                          width: isNaN(+radioSize) ? radioSize : +radioSize,
                          height: isNaN(+radioSize) ? radioSize : +radioSize,
                          backgroundColor: isSelected
                            ? radioColor
                            : 'transparent',
                          ...(!selectionStyle?.isToggle && {
                            position: 'absolute',
                            opacity: 0,
                            pointerEvents: 'none',
                          }),
                        }}
                        id={inputId}
                        disabled={loading}
                        name="productSelection"
                        className="cursor-pointer"
                        value={item?.productDetails?.id}
                        checked={isSelected}
                        onChange={async event => {
                          try {
                            if (cartData && storeData && dispatch) {
                              setLoading(true);

                              const ProductToRemove = cartData?.LineItems?.map(
                                item => {
                                  if (
                                    sortedData?.some(sortedItem =>
                                      item?.VariantID?.includes(
                                        `${sortedItem?.productDetails?.variantid}`,
                                      ),
                                    )
                                  ) {
                                    return item;
                                  }
                                },
                              ).filter(Boolean);

                              const swapPayload: {
                                ID: string;
                                addVariantId: string;
                                removeLineId: string | undefined;
                                ShopID: string;
                                StoreID: string | undefined;
                                PageID: string | undefined;
                                isAlias?: boolean;
                                pageId?: string | undefined | null;
                              } = {
                                ID: cartData?.ID,
                                addVariantId: `${item?.productDetails?.variantid}`,
                                removeLineId:
                                  ProductToRemove && ProductToRemove[0]?.ID
                                    ? ProductToRemove[0]?.ID
                                    : undefined,
                                ShopID: storeData?.ShopID,
                                StoreID: storeData?.StoreID,
                                PageID: pageId ? '' + pageId : undefined,
                              };
                              if (item.addAlias) {
                                swapPayload.isAlias = item.addAlias;
                                swapPayload.pageId = pageId;
                              }

                              const res =
                                await checkoutService.swapCartProduct(
                                  swapPayload,
                                );

                              if (res.data && res.data.Cart) {
                                dispatch(setCartData(res.data.Cart));
                                if (res.data.Cart.AvailableShippingMethods) {
                                  dispatch(
                                    setAvailableShippingMethods(
                                      res.data.Cart
                                        .AvailableShippingMethods as ShippingMethod[],
                                    ),
                                  );
                                }
                              }
                            }

                            setSelectedProduct(+event.target.value);
                            setLoading(false);
                          } catch (error) {
                            console.error('Error swapping product:', error);
                            setLoading(false);
                          } finally {
                            setLoading(false);
                          }
                        }}
                      />
                      <img
                        src={
                          item.addAlias
                            ? process.env.REACT_APP_S3_BUCKET_URL +
                              item.aliasImageUrl
                            : item.productDetails.imageUrl
                        }
                        alt={item.productDetails.name}
                        width={item?.aliasImageWidth}
                        height={item?.aliasImageHeight}
                        style={
                          isLoaded || editMode || !item.aliasImageUrl
                            ? {
                                width: imgWidth,
                                height: imgHeight,
                              }
                            : { maxHeight: imgHeight, maxWidth: imgWidth }
                        }
                        className="object-contain border rounded-md bg-white"
                        decoding="async"
                        onLoad={() => setIsLoaded(true)}
                      />
                      <div>
                        {item?.isTag &&
                          item?.tagText &&
                          tagPosition === 'right' && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: removeBackgroundColor(item.tagText),
                              }}
                              className={`${tagStyles?.isBlink === 'yes' ? 'pulsing-button' : ''} overflow-hidden`}
                              style={{
                                ...getPaddingStyles(
                                  tagStyles?.padding,
                                  currentDeviceType,
                                ),
                                width: maxContainerWidth,
                                backgroundColor: tagStyles?.backgroundColor,
                                borderTopLeftRadius: isNaN(
                                  +tagStyles?.borderTopLeft,
                                )
                                  ? tagStyles?.borderTopLeft
                                  : tagStyles?.borderTopLeft + 'px',
                                borderTopRightRadius: isNaN(
                                  +tagStyles?.borderTopRight,
                                )
                                  ? tagStyles?.borderTopRight
                                  : tagStyles?.borderTopRight + 'px',
                                borderBottomLeftRadius: isNaN(
                                  +tagStyles?.borderBottomLeft,
                                )
                                  ? tagStyles?.borderBottomLeft
                                  : tagStyles?.borderBottomLeft + 'px',
                                borderBottomRightRadius: isNaN(
                                  +tagStyles?.borderBottomRight,
                                )
                                  ? tagStyles?.borderBottomRight
                                  : tagStyles?.borderBottomRight + 'px',
                              }}
                            />
                          )}
                        <p
                          className={`${productTitle?.fontSize?.[currentDeviceType]} ${productTitle?.weight?.[currentDeviceType]} text-wrap w-full`}
                          style={{
                            color: titleColor,
                          }}>
                          {item?.addAlias
                            ? item?.aliasName
                            : item?.productDetails.name}
                        </p>
                      </div>
                    </div>
                    <span
                      className="text-sm font-semibold"
                      style={{ width: '45%' }}>
                      {item?.isDisplayPrice && item?.displayPrice ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.displayPrice,
                          }}
                        />
                      ) : (
                        <span>${item?.totalCartPrice}</span>
                      )}
                    </span>
                  </div>
                </div>
              </label>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PreviewProduct;
